import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useSEO } from '../../../hooks/useSEO';

export default function HsinchuPage() {
  useSEO({
    title: '新竹搬家公司推薦2025｜新竹竹北搬家費用價格｜科學園區搬家｜新竹搬家多少錢 0978-900-081',
    description: '新竹搬家公司推薦首選！建鈞精緻搬家提供新竹市東區、北區、香山區、竹北市、竹東鎮等地專業搬家服務。科學園區精密設備搬運、工程師搬家、實驗室搬遷專業認證。套房搬家3000元起，24小時服務，免費估價，經驗豐富團隊，客戶滿意度4.8星。立即預約：0978-900-081',
    keywords: '新竹搬家,新竹搬家公司,新竹市搬家,竹北搬家,新竹搬家推薦,新竹搬家費用,新竹搬家價格,竹北搬家公司,新竹東區搬家,新竹搬家估價,竹東搬家,新竹科學園區搬家,新竹工程師搬家,新竹精密設備搬運,新竹實驗室搬遷,新竹搬家多少錢,新竹搬家推薦ptt,新竹學生搬家,新竹套房搬家,新竹搬家評價,新竹24小時搬家,竹北高鐵特區搬家',
    ogImage: 'https://public.readdy.ai/ai/img_res/928f14d3a3cd9130ce001a0b1697198f.jpg',
    canonical: 'https://www.example.com/area/hsinchu'
  });

  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "name": "安心搬家 - 新竹搬家服務",
      "image": "https://readdy.ai/api/search-image?query=professional%20moving%20service%20team%20carefully%20transporting%20furniture%20in%20modern%20Hsinchu%20city%20residential%20area%20with%20clean%20organized%20workspace%20and%20protective%20equipment&width=1200&height=630&seq=hsinchu-moving-og&orientation=landscape",
      "@id": "https://www.example.com/area/hsinchu",
      "url": "https://www.example.com/area/hsinchu",
      "telephone": "+886-2-1234-5678",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "新竹市東區",
        "addressLocality": "新竹市",
        "addressRegion": "新竹市",
        "postalCode": "300",
        "addressCountry": "TW"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": 24.8138,
        "longitude": 120.9675
      },
      "openingHoursSpecification": {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": [
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
          "Sunday"
        ],
        "opens": "00:00",
        "closes": "23:59"
      },
      "priceRange": "$$",
      "areaServed": [
        {
          "@type": "City",
          "name": "新竹市東區"
        },
        {
          "@type": "City",
          "name": "新竹市北區"
        },
        {
          "@type": "City",
          "name": "新竹市香山區"
        },
        {
          "@type": "City",
          "name": "竹北市"
        },
        {
          "@type": "City",
          "name": "竹東鎮"
        },
        {
          "@type": "City",
          "name": "新埔鎮"
        },
        {
          "@type": "City",
          "name": "關西鎮"
        },
        {
          "@type": "City",
          "name": "湖口鄉"
        },
        {
          "@type": "City",
          "name": "新豐鄉"
        },
        {
          "@type": "City",
          "name": "芎林鄉"
        },
        {
          "@type": "City",
          "name": "橫山鄉"
        },
        {
          "@type": "City",
          "name": "北埔鄉"
        },
        {
          "@type": "City",
          "name": "寶山鄉"
        },
        {
          "@type": "City",
          "name": "峨眉鄉"
        }
      ],
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.8",
        "reviewCount": "142"
      }
    });
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  const districts = [
    { name: '東區', features: '新竹市中心，商業繁榮', tips: '市區交通繁忙，建議避開上下班時間', popular: true },
    { name: '北區', features: '科學園區核心，高科技產業', tips: '精密設備需專業防震包裝', popular: true },
    { name: '香山區', features: '海邊住宅區，環境清幽', tips: '海風鹽分較重，電子產品需特別保護' },
    { name: '竹北市', features: '縣府所在地，新興重劃區', tips: '新建案多，電梯使用需預約', popular: true },
    { name: '竹東鎮', features: '傳統市鎮，老街文化', tips: '巷弄較窄，大型車輛需評估路況' },
    { name: '新埔鎮', features: '客家文化重鎮，農業區', tips: '鄉間道路較窄，需注意車輛限制' }
  ];

  const techServices = [
    { icon: 'ri-computer-line', title: '科技設備搬遷', desc: '半導體、電子設備專業搬運', highlight: '無塵室等級防護' },
    { icon: 'ri-microscope-line', title: '實驗室搬遷', desc: '精密儀器、化學品安全搬運', highlight: '專業認證人員' },
    { icon: 'ri-building-4-line', title: '辦公室搬遷', desc: '科技公司、新創企業搬遷', highlight: '最短停工時間' },
    { icon: 'ri-home-gear-line', title: '工程師搬家', desc: '科技人才住宅搬遷服務', highlight: '彈性配合時間' }
  ];

  const faqData = [
    {
      question: '新竹搬家公司推薦哪一家？科學園區搬家找誰？',
      answer: '建鈞精緻搬家專業服務新竹市、竹北、竹東全區，特別熟悉科學園區環境和精密設備搬運。我們擁有 4.8 分高評價和 142 則客戶好評，提供專業認證人員和無塵室等級防護，是科技人才和高科技公司的首選搬家服務。累積超過 300 件科學園區搬家成功案例，包含台積電、聯發科等知名企業員工推薦。'
    },
    {
      question: '新竹科學園區搬家費用怎麼算？2025年價格多少？',
      answer: '2025年新竹地區搬家費用：工程師搬家（套房/2房）4,000 元起，科技家庭搬遷（3-4房）10,000-15,000 元起，辦公室搬遷（20-50人）15,000-30,000 元起。精密設備搬運需現場評估（含防震包裝、無塵室防護），實驗室搬遷採專案報價。我們提供免費估價服務，確保報價透明準確。'
    },
    {
      question: '新竹搬家當天可以預約嗎？急件怎麼辦？',
      answer: '建議提前 3-7 天預約。科學園區搬遷因涉及精密設備和無塵室環境，建議提前 1-2 週預約，讓我們有充足時間準備專業設備和認證人員。如有急件需求（當天或隔天搬家），可來電 0978-900-081 詢問，我們會盡力安排。工程師輪班制度我們都能彈性配合。'
    },
    {
      question: '科學園區精密設備怎麼搬運？半導體設備可以搬嗎？',
      answer: '我們提供專業精密設備搬運服務：1. 無塵室等級防護措施（Class 10,000 標準）；2. 防震防靜電包裝材料；3. 專業認證技術人員操作；4. 符合 ISO 9001 認證標準；5. 提供專業保險保障（最高 500 萬）。半導體設備、實驗室儀器、伺服器設備、光學儀器都有豐富經驗，確保設備安全無損。'
    },
    {
      question: '新竹工程師搬家有什麼特別服務？配合輪班嗎？',
      answer: '我們了解科技人才的需求，提供彈性配合服務：1. 配合輪班時間（可夜間 8 點後或假日搬家）；2. 快速搬遷服務（最短 2-3 小時完成套房搬家）；3. 精品電子產品特別保護（筆電、手機、相機等）；4. 提供臨時倉儲服務（最長 30 天）；5. 工程師優惠方案（提供員工證享折扣）。讓您工作搬家兩不誤。'
    },
    {
      question: '新竹搬家什麼時間最便宜？學生搬家有優惠嗎？',
      answer: '平日（週一至週五）和非月底時段價格較優惠，可省 10-20%。科學園區工程師可選擇夜間搬家（晚上 8 點後），避開交通尖峰且價格更優惠。學生搬家（清大、交大、中華大學）我們提供優惠方案，套房搬遷 2,500 元起，提供學生證可享額外折扣。我們提供 24 小時服務，配合您的輪班時間。'
    },
    {
      question: '竹北高鐵特區搬家方便嗎？新建案怎麼搬？',
      answer: '竹北高鐵特區多為新建大樓，電梯設備完善，搬家相對便利。新建案搬家需注意：1. 提前向建商或管委會申請搬家許可；2. 確認電梯使用時間（通常 8:00-17:00）；3. 電梯需做完整保護措施；4. 部分社區收取電梯使用費 500-1500 元；5. 新成屋地板需特別保護。我們會提前與社區管理處協調，確保搬運順暢。'
    },
    {
      question: '新竹到台北搬家需要多久時間？費用多少？',
      answer: '新竹到台北約 70-90 公里，車程約 1.5-2 小時（依交通狀況）。一般兩房家庭搬家含打包、搬運、定位，全程約需 6-8 小時。費用約 18,000-25,000 元（含基本搬運費 + 距離費 + 樓層費）。三房搬家約 25,000-35,000 元。科學園區工程師搬家我們提供優惠方案，歡迎來電詢問。我們會依您的時間需求安排最佳搬運計畫。'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="relative h-[500px] flex items-center justify-center">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=beautiful%20aerial%20view%20of%20Hsinchu%20city%20skyline%20with%20modern%20buildings%20Science%20Park%20and%20green%20mountains%20in%20background%20during%20golden%20hour%20creating%20warm%20professional%20atmosphere&width=1920&height=500&seq=hsinchu-hero-bg&orientation=landscape"
            alt="新竹市景"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
        </div>
        <div className="relative z-10 text-center text-white px-4">
          <h1 className="text-5xl font-bold mb-4">新竹搬家公司推薦</h1>
          <p className="text-xl mb-8">專業服務新竹市、竹北市及新竹縣各鄉鎮</p>
          <div className="flex gap-4 justify-center flex-wrap">
            <Link
              to="/quote"
              className="bg-orange-500 hover:bg-orange-600 text-white px-8 py-3 rounded-lg font-semibold transition-colors whitespace-nowrap"
            >
              免費估價
            </Link>
            <Link
              to="/contact"
              className="bg-white hover:bg-gray-100 text-gray-900 px-8 py-3 rounded-lg font-semibold transition-colors whitespace-nowrap"
            >
              立即諮詢
            </Link>
          </div>
        </div>
      </section>

      {/* Service Areas */}
      <section className="py-16 px-4">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-3xl font-bold text-center mb-12">新竹搬家服務區域</h2>
          
          {/* 新竹市 */}
          <div className="mb-12">
            <h3 className="text-2xl font-bold mb-6 text-orange-500">新竹市（3區）</h3>
            <div className="grid md:grid-cols-3 gap-6">
              <div className="bg-gray-50 p-6 rounded-lg hover:shadow-lg transition-shadow">
                <h4 className="text-xl font-bold mb-3">東區</h4>
                <p className="text-gray-600 mb-4">新竹市中心，商業區密集，包含火車站周邊、清大、交大學區。</p>
                <ul className="text-sm text-gray-600 space-y-2">
                  <li>• 學生套房搬遷專案</li>
                  <li>• 市區停車規劃</li>
                  <li>• 電梯大樓搬運</li>
                </ul>
              </div>
              <div className="bg-gray-50 p-6 rounded-lg hover:shadow-lg transition-shadow">
                <h4 className="text-xl font-bold mb-3">北區</h4>
                <p className="text-gray-600 mb-4">住宅區為主，包含南寮漁港、新竹漁港周邊社區。</p>
                <ul className="text-sm text-gray-600 space-y-2">
                  <li>• 家庭搬遷服務</li>
                  <li>• 透天厝搬運</li>
                  <li>• 社區搬家協調</li>
                </ul>
              </div>
              <div className="bg-gray-50 p-6 rounded-lg hover:shadow-lg transition-shadow">
                <h4 className="text-xl font-bold mb-3">香山區</h4>
                <p className="text-gray-600 mb-4">新竹市最大行政區，包含香山、內湖等地區。</p>
                <ul className="text-sm text-gray-600 space-y-2">
                  <li>• 長途搬家服務</li>
                  <li>• 大型家具搬運</li>
                  <li>• 跨區搬遷專案</li>
                </ul>
              </div>
            </div>
          </div>

          {/* 新竹縣 */}
          <div>
            <h3 className="text-2xl font-bold mb-6 text-orange-500">新竹縣（11鄉鎮市）</h3>
            <div className="grid md:grid-cols-3 gap-6">
              <div className="bg-gray-50 p-6 rounded-lg hover:shadow-lg transition-shadow">
                <h4 className="text-xl font-bold mb-3">竹北市</h4>
                <p className="text-gray-600 mb-4">新竹縣政府所在地，高鐵特區、科技園區周邊新興住宅區。</p>
                <ul className="text-sm text-gray-600 space-y-2">
                  <li>• 新成屋搬遷</li>
                  <li>• 高級社區服務</li>
                  <li>• 精緻搬家方案</li>
                </ul>
              </div>
              <div className="bg-gray-50 p-6 rounded-lg hover:shadow-lg transition-shadow">
                <h4 className="text-xl font-bold mb-3">竹東鎮</h4>
                <p className="text-gray-600 mb-4">新竹縣第二大城鎮，工業區與住宅區並存。</p>
                <ul className="text-sm text-gray-600 space-y-2">
                  <li>• 工廠搬遷服務</li>
                  <li>• 辦公室搬遷</li>
                  <li>• 設備搬運</li>
                </ul>
              </div>
              <div className="bg-gray-50 p-6 rounded-lg hover:shadow-lg transition-shadow">
                <h4 className="text-xl font-bold mb-3">湖口鄉</h4>
                <p className="text-gray-600 mb-4">工業區密集，包含新豐、湖口工業區。</p>
                <ul className="text-sm text-gray-600 space-y-2">
                  <li>• 廠房搬遷</li>
                  <li>• 機器設備搬運</li>
                  <li>• 倉儲搬遷</li>
                </ul>
              </div>
              <div className="bg-gray-50 p-6 rounded-lg hover:shadow-lg transition-shadow">
                <h4 className="text-xl font-bold mb-3">新豐鄉</h4>
                <p className="text-gray-600 mb-4">濱海鄉鎮，近年發展快速。</p>
                <ul className="text-sm text-gray-600 space-y-2">
                  <li>• 透天厝搬遷</li>
                  <li>• 跨縣市搬家</li>
                  <li>• 長途運輸</li>
                </ul>
              </div>
              <div className="bg-gray-50 p-6 rounded-lg hover:shadow-lg transition-shadow">
                <h4 className="text-xl font-bold mb-3">關西鎮</h4>
                <p className="text-gray-600 mb-4">客家文化重鎮，山區地形。</p>
                <ul className="text-sm text-gray-600 space-y-2">
                  <li>• 山區搬家</li>
                  <li>• 狹窄巷道搬運</li>
                  <li>• 老屋搬遷</li>
                </ul>
              </div>
              <div className="bg-gray-50 p-6 rounded-lg hover:shadow-lg transition-shadow">
                <h4 className="text-xl font-bold mb-3">新埔鎮</h4>
                <p className="text-gray-600 mb-4">傳統客家小鎮，柿餅產地。</p>
                <ul className="text-sm text-gray-600 space-y-2">
                  <li>• 鄉鎮搬家</li>
                  <li>• 農村搬遷</li>
                  <li>• 三合院搬運</li>
                </ul>
              </div>
              <div className="bg-gray-50 p-6 rounded-lg hover:shadow-lg transition-shadow">
                <h4 className="text-xl font-bold mb-3">芎林鄉</h4>
                <p className="text-gray-600 mb-4">近竹東，山區鄉鎮。</p>
                <ul className="text-sm text-gray-600 space-y-2">
                  <li>• 山區搬運</li>
                  <li>• 小型搬家</li>
                  <li>• 家具搬運</li>
                </ul>
              </div>
              <div className="bg-gray-50 p-6 rounded-lg hover:shadow-lg transition-shadow">
                <h4 className="text-xl font-bold mb-3">橫山鄉</h4>
                <p className="text-gray-600 mb-4">山區鄉鎮，地形起伏。</p>
                <ul className="text-sm text-gray-600 space-y-2">
                  <li>• 山區搬家</li>
                  <li>• 長途運輸</li>
                  <li>• 特殊地形搬運</li>
                </ul>
              </div>
              <div className="bg-gray-50 p-6 rounded-lg hover:shadow-lg transition-shadow">
                <h4 className="text-xl font-bold mb-3">北埔鄉</h4>
                <p className="text-gray-600 mb-4">觀光小鎮，老街文化。</p>
                <ul className="text-sm text-gray-600 space-y-2">
                  <li>• 老街搬運</li>
                  <li>• 古蹟周邊搬家</li>
                  <li>• 小巷搬運</li>
                </ul>
              </div>
              <div className="bg-gray-50 p-6 rounded-lg hover:shadow-lg transition-shadow">
                <h4 className="text-xl font-bold mb-3">寶山鄉</h4>
                <p className="text-gray-600 mb-4">近科學園區，新興住宅區。</p>
                <ul className="text-sm text-gray-600 space-y-2">
                  <li>• 別墅搬遷</li>
                  <li>• 山坡地搬運</li>
                  <li>• 高級住宅服務</li>
                </ul>
              </div>
              <div className="bg-gray-50 p-6 rounded-lg hover:shadow-lg transition-shadow">
                <h4 className="text-xl font-bold mb-3">峨眉鄉</h4>
                <p className="text-gray-600 mb-4">山區小鄉，自然景觀豐富。</p>
                <ul className="text-sm text-gray-600 space-y-2">
                  <li>• 偏遠地區搬家</li>
                  <li>• 山區運輸</li>
                  <li>• 小型搬遷</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Features */}
      <section className="py-16 px-4 bg-gray-50">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-3xl font-bold text-center mb-12">新竹搬家服務特色</h2>
          <div className="grid md:grid-cols-4 gap-6">
            <div className="bg-white p-6 rounded-lg text-center hover:shadow-lg transition-shadow">
              <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-building-line text-3xl text-orange-500"></i>
              </div>
              <h3 className="text-xl font-bold mb-2">科學園區專業</h3>
              <p className="text-gray-600 text-sm">熟悉新竹科學園區、竹北生醫園區搬遷流程</p>
            </div>
            <div className="bg-white p-6 rounded-lg text-center hover:shadow-lg transition-shadow">
              <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-home-smile-line text-3xl text-orange-500"></i>
              </div>
              <h3 className="text-xl font-bold mb-2">學區搬家經驗</h3>
              <p className="text-gray-600 text-sm">清大、交大、中華大學學生搬家專案</p>
            </div>
            <div className="bg-white p-6 rounded-lg text-center hover:shadow-lg transition-shadow">
              <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-map-pin-line text-3xl text-orange-500"></i>
              </div>
              <h3 className="text-xl font-bold mb-3">在地深耕服務</h3>
              <p className="text-gray-600 text-sm">熟悉新竹各區道路、停車、電梯預約</p>
            </div>
            <div className="bg-white p-6 rounded-lg text-center hover:shadow-lg transition-shadow">
              <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-time-line text-3xl text-orange-500"></i>
              </div>
              <h3 className="text-xl font-bold mb-2">24小時服務</h3>
              <p className="text-gray-600 text-sm">配合您的時間，假日、夜間搬家都可安排</p>
            </div>
          </div>
        </div>
      </section>

      {/* Pricing */}
      <section className="py-16 px-4">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl font-bold text-center mb-12">新竹搬家費用參考</h2>
          <div className="bg-white border border-gray-200 rounded-lg overflow-hidden">
            <table className="w-full">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-4 text-left font-semibold">搬家類型</th>
                  <th className="px-6 py-4 text-left font-semibold">區域範圍</th>
                  <th className="px-6 py-4 text-left font-semibold">參考價格</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                <tr>
                  <td className="px-6 py-4">套房搬家</td>
                  <td className="px-6 py-4">新竹市區內</td>
                  <td className="px-6 py-4 text-orange-500 font-semibold">NT$ 3,500 起</td>
                </tr>
                <tr>
                  <td className="px-6 py-4">2房家庭搬家</td>
                  <td className="px-6 py-4">新竹市、竹北市</td>
                  <td className="px-6 py-4 text-orange-500 font-semibold">NT$ 8,000 起</td>
                </tr>
                <tr>
                  <td className="px-6 py-4">3房家庭搬家</td>
                  <td className="px-6 py-4">新竹縣市</td>
                  <td className="px-6 py-4 text-orange-500 font-semibold">NT$ 12,000 起</td>
                </tr>
                <tr>
                  <td className="px-6 py-4">辦公室搬遷</td>
                  <td className="px-6 py-4">科學園區、竹北</td>
                  <td className="px-6 py-4 text-orange-500 font-semibold">NT$ 15,000 起</td>
                </tr>
                <tr>
                  <td className="px-6 py-4">跨縣市搬家</td>
                  <td className="px-6 py-4">新竹→台北/桃園</td>
                  <td className="px-6 py-4 text-orange-500 font-semibold">NT$ 18,000 起</td>
                </tr>
              </tbody>
            </table>
          </div>
          <p className="text-center text-gray-600 mt-6 text-sm">
            * 實際費用依物品數量、樓層、距離等因素調整，歡迎來電免費估價
          </p>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-16 px-4 bg-gray-50">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl font-bold text-center mb-12">新竹搬家常見問題</h2>
          <div className="space-y-4">
            <details className="bg-white p-6 rounded-lg shadow-sm">
              <summary className="font-semibold cursor-pointer">新竹科學園區搬家需要注意什麼？</summary>
              <p className="mt-4 text-gray-600">科學園區搬家需提前申請通行證，我們會協助處理園區門禁、停車位申請、電梯預約等事宜。建議選擇非上下班尖峰時段搬運，避免交通壅塞。</p>
            </details>
            <details className="bg-white p-6 rounded-lg shadow-sm">
              <summary className="font-semibold cursor-pointer">竹北高鐵特區搬家方便嗎？</summary>
              <p className="mt-4 text-gray-600">竹北高鐵特區多為新建大樓，電梯設備完善，搬家相對便利。我們會提前與社區管理處協調搬家時間、電梯使用，確保搬運順暢。</p>
            </details>
            <details className="bg-white p-6 rounded-lg shadow-sm">
              <summary className="font-semibold cursor-pointer">清大、交大學生搬家有優惠嗎？</summary>
              <p className="mt-4 text-gray-600">我們提供學生搬家專案，套房搬家優惠價格，包含基本打包材料。建議多位同學一起預約，可享團體優惠。</p>
            </details>
            <details className="bg-white p-6 rounded-lg shadow-sm">
              <summary className="font-semibold cursor-pointer">新竹山區搬家會加價嗎？</summary>
              <p className="mt-4 text-gray-600">關西、橫山、北埔等山區因路況較複雜，可能需要較小型車輛或增加人力，費用會依實際情況調整。建議先預約現場估價，我們會提供最合理的報價。</p>
            </details>
            <details className="bg-white p-6 rounded-lg shadow-sm">
              <summary className="font-semibold cursor-pointer">新竹到台北搬家需要多久時間？</summary>
              <p className="mt-4 text-gray-600">新竹到台北約70-90公里，車程約1.5-2小時。一般3房家庭搬家含打包、搬運、定位，全程約需6-8小時。我們會依您的時間需求安排最佳搬運計畫。</p>
            </details>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 px-4 bg-gradient-to-r from-orange-500 to-orange-600 text-white">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl font-bold mb-4">立即預約新竹搬家服務</h2>
          <p className="text-xl mb-8 opacity-90">專業團隊、透明收費、安心保障</p>
          <div className="flex gap-4 justify-center flex-wrap">
            <Link
              to="/quote"
              className="bg-white hover:bg-gray-100 text-orange-500 px-8 py-3 rounded-lg font-semibold transition-colors whitespace-nowrap"
            >
              線上估價
            </Link>
            <a
              href="tel:+886-2-1234-5678"
              className="bg-orange-700 hover:bg-orange-800 text-white px-8 py-3 rounded-lg font-semibold transition-colors whitespace-nowrap"
            >
              <i className="ri-phone-line mr-2"></i>
              立即來電
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}